import React from 'react';
import {useTranslation} from "react-i18next";
import {signOut} from "../../services/authentication.service";
import {useNavigate} from 'react-router-dom';

const CustomNavbar: React.FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isSettingsView = () => {
        const location = window.location.href;
        return location.includes('settings');
    }
    const handleNavigate = () => {
        isSettingsView() ? navigate('/', { replace: true }) : navigate('settings', { replace: true });

    }
    return (
        <div className='custom-navbar'>
            <div>
                {t('companyName')}
            </div>
            <div className='d-flex'>
                <div className='default-menu-item' onClick={() => handleNavigate()}>{ isSettingsView() ? t('mainview') : t('settings')}</div>
                <div className='default-menu-item' onClick={() => signOut()}>{t('logout')}</div>
            </div>
        </div>
    )
}

export default CustomNavbar;
